import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash in the URL (like #section), don't scroll to top
    if (hash) {
      return;
    }
    
    // Use requestAnimationFrame to avoid forced reflow
    // This batches the scroll operation with the browser's rendering cycle
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [pathname, hash]);

  return null;
};
